



































import Vue from 'vue';
import { mapState } from 'vuex';
import TradeInSelected from '@/components/dumb/TradeInSelected.vue';
import Analytics from '@/mixins/analytics';
export default Vue.extend({
	name: 'TradeIn', 
	components: {
		TradeInSelected
	},
	computed: {
		...mapState({
			tradeIn(): any { return this.$store.state.tradeIn },
			tradeApp(): any { return this.$store.state.tradeValuationApp }
		}), 
		tradeInComment(): string {
			return `${this.tradeIn.km} km<br>${this.tradeIn.comment || ''}`;
		}
	},
	methods: {
		handleGetValuationClick(): void {
			if (this.tradeApp.tradeValuationEnabled){
				Analytics.sendEvent({
					"event": "buttonClick",
					"buttonName": "Get a Valuation"
				});
			}
			else {
				Analytics.sendEvent({
					"event": "buttonClick",
					"buttonName": "Trade-in Enquiry"
				});
			}
			this.$router.push({name:'TradeInPage', query: this.$route.query});
		}, 
		handleRemoveFallbackClick(): void {
			Analytics.sendEvent({
				'event':'buttonClick',
				'buttonName':'Trade In - Remove Vehicle'
			});
			this.$store.commit('setTradeIn', {
				hasTradeIn: false,
				vehicleModel: '',
				comment: '',
				year: '',
				km: ''
			});
		},
		handleEditFallbackClick(): void {
			Analytics.sendEvent({
				'event':'buttonClick',
				'buttonName':'Trade In - Edit Vehicle'
			});
			this.$router.push({name:'TradeInPage', query: this.$route.query});
		},
		handleEditClick(): void {
			Analytics.sendEvent({
				'event':'buttonClick',
				'buttonName':'Trade In - Edit Vehicle'
			});
			this.$store.commit('setTradeApp', {
				car: {
					kilometres: this.tradeApp.kilometers, 
					valuationData: null, 
					formData: this.tradeApp.car.formData, 
					optionData: this.tradeApp.car.optionData
				}
			});
			this.$router.push({name:'TradeInPage', query: this.$route.query});
		},
		handleRemoveClick(): void {
			Analytics.sendEvent({
				'event':'buttonClick',
				'buttonName':'Trade In - Remove Vehicle'
			});
			this.$store.commit('setTradeApp', {
				car: {
					kilometres: null, 
					valuationData: null, 
					formData: {}, 
					optionData: {}
				}
			});
		}
	}
});
